module.exports = __webpack_public_path__ + "5adfd676d31e3b286f072b71c639378c.svg";